import { render, staticRenderFns } from "./ThirdPartyCollapse.vue?vue&type=template&id=710bc226&scoped=true&"
import script from "./ThirdPartyCollapse.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyCollapse.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyCollapse.vue?vue&type=style&index=0&id=710bc226&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710bc226",
  null
  
)

export default component.exports